import React from 'react'
import Select from 'react-select'
import Label from './Label'
import ErrorMessage from './ErrorMessage'
import { ChevronDown, ChevronUp } from 'react-bootstrap-icons'
import { useFieldsLocked } from '../../contexts/ReadOnlyContext'

export default function ReactSelect({
  components,
  disabled: disabledProp,
  error,
  label,
  name,
  onBlur = () => {},
  onChange = () => {},
  onInputChange,
  onMenuScrollToBottom,
  options,
  placeholder,
  showAsterisk,
  noLabelPadding,
  value,
  isClearable = false,
  isSearchable = true,
  filterOption,
}) {
  const fieldsLocked = useFieldsLocked()
  const disabled = disabledProp || fieldsLocked

  const customAriaLiveMessages = {
    guidance: () => '',
    onFocus: () => '',
    onFilter: () => '',
    onCreateOption: () => '',
    onSelect: () => '',
    onInputChange: () => '',
    onClose: () => '',
    onOpen: () => '',
    onClear: () => '',
    onRemove: () => '',
  };

  const DropdownIndicator = (props) => {
    const { selectProps: { menuIsOpen } } = props;
    return (
      <div className="absolute right-3 top-1/2 transform -translate-y-1/2">
        {menuIsOpen ? <ChevronUp className='text-gray-500 dark:text-gray-400' /> : <ChevronDown className='text-gray-500 dark:text-gray-400' />}
      </div>
    );
  };

  const setMenuWidth = (ref) => {
    if (ref) {
      const width = ref.getBoundingClientRect().width;
      ref.style.setProperty('--select-width', `${width}px`);
    }
  };

  // react-select's own scroll-chaining guard attaches its wheel listener to
  // the menu-list node and cancels the event once it thinks there's no
  // scroll room left. If the outer menu also constrains height/overflow,
  // the menu-list never gets genuine scroll room and every wheel tick gets
  // cancelled before it can bubble - so only dragging the native scrollbar
  // thumb (which bypasses wheel listeners) works. Keep exactly one
  // scrollable element (menuList) so that guard's math is correct.
  const customStyles = {
    // `menu` never gets its own max-height, so it always auto-sizes to fit
    // `menuList` exactly - `hidden` here only clips menuList's square
    // corners to menu's rounded border-radius, it never needs to scroll.
    menu: (base) => ({ ...base, maxHeight: 'none', overflow: 'hidden' }),
    menuList: (base) => ({ ...base, maxHeight: 242, overflowY: 'auto' }),
  };

  return (
    <>
      <Label
        label={label}
        noLabelPadding={noLabelPadding}
        showAsterisk={showAsterisk}
      />

      <div className={error ? 'error' : ''} ref={setMenuWidth}>
        <Select
          classNamePrefix="react-select"
          isClearable={isClearable}
          isSearchable={isSearchable}
          ariaLiveMessages={customAriaLiveMessages}
          components={{
            ...components,
            DropdownIndicator,
            IndicatorSeparator: null
          }}
          isDisabled={disabled}
          name={name}
          onChange={onChange}
          onBlur={onBlur}
          onInputChange={onInputChange}
          onMenuScrollToBottom={onMenuScrollToBottom}
          filterOption={filterOption}
          options={options}
          placeholder={placeholder}
          value={(value || value === 0) ? { label: options.find(option => option.value === value)?.label, value } : null}
          menuPosition="fixed"
          menuPlacement="auto"
          styles={customStyles}
        />
      </div>

      {error && <ErrorMessage text={error} />}
    </>
  );
}
